<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="银行卡号" prop="bankNo" >
        <a-input v-model="form.bankNo" placeholder="请输入"/>
      </a-form-model-item>
      <a-form-model-item label="银行名称" prop="bankName" >
        <a-input v-model="form.bankName" placeholder="请输入"/>
      </a-form-model-item>
      <a-form-model-item label="所属支行" prop="bankSubName" >
        <a-input v-model="form.bankSubName" placeholder="请输入"/>
      </a-form-model-item>
      <a-form-model-item label="真实姓名" prop="realName" >
        <a-input v-model="form.realName" placeholder="请输入"/>
      </a-form-model-item>
      <a-form-model-item label="手机号" prop="mobile" >
        <a-input v-model="form.mobile" placeholder="请输入"/>
      </a-form-model-item>
      <a-form-model-item label="身份证人像面" prop="idCardFront">
        <a-upload
          :customRequest="fileUploadRequest"
          list-type="picture-card"
          :showUploadList="false"
          :beforeUpload="beforeUpload"
          @change="handleChange">
          <img v-if="form.idCardFront" :src="form.idCardFront" alt="图片" style="height:104px;max-width:300px"/>
          <div v-else>
            <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
        <a-button type="primary" @click="handlePreview">预览</a-button>
        <br/>
        <span style="color:#ff0000">支持JPG、PNG图片文件 </span>
        <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
          <img alt="example" style="width: 100%" :src="previewImage"/>
        </a-modal>
      </a-form-model-item>
      <a-form-model-item label="身份证国徽面" prop="idCardReverse" >
        <a-upload
          :customRequest="fileUploadRequest1"
          list-type="picture-card"
          :showUploadList="false"
          :beforeUpload="beforeUpload"
          @change="handleChange1">
          <img v-if="form.idCardReverse" :src="form.idCardReverse" alt="图片" style="height:104px;max-width:300px"/>
          <div v-else>
            <a-icon :type="uploadLoading1 ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
        <a-button type="primary" @click="handlePreview1">预览</a-button>
        <br/>
        <span style="color:#ff0000">支持JPG、PNG图片文件 </span>
        <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
          <img alt="example" style="width: 100%" :src="previewImage"/>
        </a-modal>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { updateOther } from '@/api/biz/user'
import UploadFileToOSS from '@/utils/upload-file-to-oss'

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}
export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      uploadLoading: false,
      uploadLoading1: false,
      type: 1,
      // 表单参数
      form: {
        id: null,
        idCardFront: null,
        idCardReverse: null,
        bankNo: null,
        bankName: null,
        bankSubName: null,
        realName: null,
        mobile: null
      },
      previewImage: null,
      previewVisible: false,
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        bankNo: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        bankName: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        bankSubName: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        realName: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        idCardFront: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        idCardReverse: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoading = true
        return
      }
      if (info.file.status === 'done') {
        this.uploadLoading = false
        this.form.idCardFront = info.file.originFileObj.ossUrl
      }
    },
    fileUploadRequest(fileInfo) {
      this.uploadLoading = true
      new UploadFileToOSS([fileInfo.file], {
        finally: (res) => {
          // Log.info('multi-img-upload', res);
          const ossUrl = res[0].url
          fileInfo.file.ossUrl = ossUrl
          fileInfo.file.ossName = ossUrl
          fileInfo.onSuccess()
        }
      })
    },
    handleCancel() {
      this.previewVisible = false
    },
    async handlePreview() {
      this.previewImage = this.form.idCardFront
      this.previewVisible = true
    },
    async handlePreview1() {
      this.previewImage = this.form.idCardReverse
      this.previewVisible = true
    },
    handleChange1(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoading1 = true
        return
      }
      if (info.file.status === 'done') {
        this.uploadLoading1 = false
        this.form.idCardReverse = info.file.originFileObj.ossUrl
      }
    },
    fileUploadRequest1(fileInfo) {
      this.uploadLoading1 = true
      new UploadFileToOSS([fileInfo.file], {
        finally: (res) => {
          // Log.info('multi-img-upload', res);
          const ossUrl = res[0].url
          fileInfo.file.ossUrl = ossUrl
          fileInfo.file.ossName = ossUrl
          fileInfo.onSuccess()
        }
      })
    },
    beforeUpload: function (file) {
      return new Promise((resolve, reject) => {
        if (file.size > 5 * 1024 * 1000) {
          this.$message.warning('图片大小不能超过5M')
          return reject(false)
        }

        var fileType = file.type
        if (fileType.indexOf('image') < 0) {
          this.$message.warning('请上传图片')
          return reject(false)
        }
        resolve(true)
      })
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        idCardFront: null,
        idCardReverse: null,
        bankNo: null,
        bankName: null,
        bankSubName: null,
        realName: null,
        mobile: null
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      this.form.id = id
      this.open = true
      this.formTitle = '补录其他信息'
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          updateOther(this.form).then(response => {
            this.$message.success(
              '修改成功',
              3
            )
            this.open = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
